import Header from "components/header";
import Footer from "components/Footer";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

const CareersPage = () => {
  const [t] = useTranslation("global");

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{"EMPORIUM POINT | Careers"}</title>
        <meta name="og:title" content={"EMPORIUM POINT | Careers"} />
      </Helmet>
      <div className="font-[Yekan] mt-[99px] md:mt-[83px]">
        <Header />
        <div className="max-w-4xl mx-auto p-6">
          <h1 className="text-3xl font-bold mb-6">{t("careers.title")}</h1>
          <p className="mb-4">{t("careers.intro")}</p>
          <p className="mb-4">{t("careers.values")}</p>
          <p>{t("careers.cta")}</p>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default CareersPage;
